/**
 * Safe DEV/PROD flags for code shared with Lambda's plain-esbuild CJS bundle, where
 * `import.meta.env` doesn't exist at all (`import.meta` itself is an empty esbuild shim
 * there, so any `.env` access resolves to `undefined`).
 *
 * Deliberately keeps `import.meta.env.DEV`/`.PROD` as literal, directly-dotted expressions
 * instead of reading them through a captured variable or bracket access: Vite's SSR dev
 * module runner implements `import.meta.env` as a Proxy that only supports this exact
 * literal access pattern and throws "Dynamic access of import.meta.env is not supported"
 * for anything else (a captured reference, computed key, etc). Vike's build has the mirror
 * restriction — it statically substitutes only this literal pattern and replaces any other
 * shape of the expression (e.g. `import.meta.env?.DEV`, or `import.meta.env` captured in a
 * variable) with `null` (see https://vike.dev/env). Both effectively require: write
 * `import.meta.env.PROP` exactly as-is at the usage site, nowhere else.
 *
 * The `typeof import.meta.env !== 'undefined'` guard is itself a bare (non-dotted)
 * reference, which Vike nulls to `typeof null`, i.e. `'object'` — always true in the
 * Vite/Vike-built app, which is correct there since the real env object always exists in
 * that context. In the Lambda bundle `import.meta.env` is genuinely `undefined`, so
 * `typeof` correctly evaluates to `'undefined'` and the ternary short-circuits before ever
 * reading `.DEV`/`.PROD`, avoiding a crash.
 */
export const VITE_DEV: boolean =
  typeof import.meta.env !== 'undefined' ? Boolean(import.meta.env.DEV) : false;
export const VITE_PROD: boolean =
  typeof import.meta.env !== 'undefined' ? Boolean(import.meta.env.PROD) : false;
